export default function VoiceTranscript({
    transcript,
    isPlayingAudio,
    isConnecting,
    isRecording,
    theme
}) {
    const getPlaceholderText = () => {
        if (isConnecting) return "Приєднююсь...";
        if (isRecording) return "Можете говорити";
        return "Натисніть \"Почати\"  щоб говорити";
    };

    const styles = {
        transcriptBox: {
            backgroundColor: theme.messageBg || "rgba(255, 255, 255, 0.05)",
            borderRadius: "12px",
            padding: "16px",
            minHeight: "80px",
            maxHeight: "160px",
            overflowY: "auto",
            marginBottom: "20px",
            color: theme.text,
            fontSize: "14px",
            lineHeight: "1.6",
            border: `1px solid ${theme.buttonBg}20`,
        },
        placeholder: {
            color: theme.mutedText || "rgba(255, 255, 255, 0.3)",
            fontSize: "13px",
        },
    };

    return (
        <div style={styles.transcriptBox}>
            {transcript ? (
                transcript
            ) : (
                <div style={styles.placeholder}>
                    {getPlaceholderText()}
                </div>
            )}
        </div>
    );
}
